/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Modal, Space, Checkbox, Spin } from 'antd'
import { AvatarStatus } from 'components/elements/AvatarStatus'
import { BaseButton } from 'components/elements/BaseButton'
import { FC, useEffect, useState } from 'react'
import { TGroupName } from 'types'
import { useTssDltLeadsMutation } from 'features/settings/api'
import { capitalizeFirstLetter } from 'utils/functions'
import useFetchPage2 from 'hooks/useFetchPage2'
import InfiniteScroll from 'react-infinite-scroller'

const TSSLeadsModal: FC<{
 onCancel?: () => void
 type?: TGroupName
 //  leads: {
 //   name?: string
 //   id: number
 //  }[]
 refetch?: () => void
 tagId?: number
 tagName?: string
 isMergable?: boolean
}> = ({
 onCancel,
 type,
 // leads,
 refetch,
 tagId,
 tagName,
 isMergable = true,
}) => {
 const [Ids, setIds] = useState<any[]>([])
 const [selectAll, setSelectAll] = useState(false)
 const [unSelected, setUnSelected] = useState<any[]>([])
 const [tssDltLeads, { isLoading: dltLeadsLoading }] = useTssDltLeadsMutation()

 const onDltLeads = async (): Promise<void> => {
  await tssDltLeads({
   tag_id: tagId,
   lead_id: Ids,
   select_all: selectAll,
   ...(selectAll ? { unselected: unSelected } : {}),
  }).unwrap()
  onCancel?.()
  refetch?.()
 }

 const {
  isLoading,
  hasMore,
  fetchMore,
  total,
  // refetch,
  flatData: leads,
  isRefetching,
  // meta,
 } = useFetchPage2<{
  name?: string
  id: number
 }>('get-group-leads', {
  method: 'get',
  params: `type=${type}&type_id=${tagId}`,
 })

 useEffect(() => {
  if (leads && leads?.length > 0 && selectAll) {
   setIds(leads.map((x) => x.id))
  }
 }, [leads, selectAll])

 return (
  <Modal
   visible
   onCancel={onCancel}
   className="viewportModal"
   title={`Leads with ${type} '${tagName}'`}
   // Actions in the Modal footer stay fixed while the list scrolls
   footer={
    <Space>
     <BaseButton customClass="btn-secondary-custom" onClick={onCancel}>
      Cancel
     </BaseButton>
     {/* {Ids && Ids.length > 0 && type === 'tag' && ( */}
     {type === 'tag' && isMergable && (
      <BaseButton
       loading={dltLeadsLoading}
       buttonType="danger"
       onClick={onDltLeads}
       disabled={!(Ids && Ids.length > 0)}
      >
       Remove Tag (
       {selectAll ? Number(total ?? 0) - unSelected.length : Ids.length})
      </BaseButton>
     )}
     {/* )} */}
    </Space>
   }
  >
   <Spin
    className="w-100 text-center"
    wrapperClassName="viewportModal-spin"
    // style={{ height: '200px' }}
    spinning={isLoading}
   >
    <div className="viewportModal-scroll">
     {type === 'tag' && isMergable && leads && (leads?.length ?? 0) > 0 && (
      // Sticky inside the scroll area so its checkbox aligns with the list's
      <div
       className="d-flex justify-content-end viewportModal-sticky"
       style={{ fontWeight: '500', paddingBottom: '8px' }}
      >
       <span
        style={{ paddingRight: '6px', cursor: 'pointer' }}
        onClick={() =>
         setIds((prv) =>
          prv?.length === leads.length ? [] : leads.map((x) => x.id),
         )
        }
       >
        Select All
       </span>
       <Checkbox
        onChange={({ target }) => {
         setSelectAll(target.checked)
         if (target.checked) {
          setUnSelected([])
         }
         setIds((prv) =>
          prv?.length === leads.length ? [] : leads.map((x) => x.id),
         )
        }}
        checked={Ids?.length === leads.length}
       />
      </div>
     )}
     {leads && (leads?.length ?? 0) > 0 && (
      <InfiniteScroll
       pageStart={0}
       loadMore={fetchMore}
       hasMore={hasMore}
       loader={
        <div className="text-center py-2">
         <Spin />
        </div>
       }
       useWindow={false}
      >
       {leads?.map((item, index) => (
        <AvatarStatus
         key={index}
         title={item.name}
         className="action-active-leads "
         //  onClickWrapper={() => {
         //   setIds((prv) => {
         //    const find = prv.find((m) => m === item.id)
         //    if (find) {
         //     const filter = prv.filter((x) => x !== item.id)
         //     return [...filter]
         //    }
         //    return [...prv, item.id]
         //   })
         //  }}
         {...(type === 'tag' && isMergable
          ? {
             action: <Checkbox checked={Ids.find((x) => x === item.id)} />,
             onClickWrapper: () => {
              const find = Ids.find((m) => m === item.id)
              if (find) {
               setIds(Ids.filter((x) => x !== item.id))
               if (selectAll) {
                setUnSelected((prv) => [...prv, item.id])
               } else {
                setUnSelected([])
               }
              } else {
               if (selectAll) {
                setUnSelected((prv) => prv.filter((x) => x !== item.id))
               } else {
                setUnSelected([])
               }
               setIds((prv) => [...prv, item.id])
              }
              // setIds((prv) => {
              //  const find = prv.find((m) => m === item.id)
              //  if (find) {
              //   const filter = prv.filter((x) => x !== item.id)
              //   // setUnSelected((prv) => [...prv, item.id])
              //   return [...filter]
              //  }
              //  //  setUnSelected((prv) => prv.filter((x) => x !== item.id))

              //  return [...prv, item.id]
              // })
             },
            }
          : {})}
         //  action={
         //   <Checkbox
         //    //    onChange={() => {
         //    //     setIds((prv) => {
         //    //      const find = prv.find((m) => m === item.id)
         //    //      if (find) {
         //    //       const filter = prv.filter((x) => x !== item.id)
         //    //       return [...filter]
         //    //      }
         //    //      return [...prv, item.id]
         //    //     })
         //    //    }}
         //    checked={Ids.find((x) => x === item.id)}
         //   />
         //  }
        />
       ))}
      </InfiniteScroll>
     )}
    </div>
   </Spin>
  </Modal>
 )
}

export default TSSLeadsModal
